import styled, { css } from "styled-components";
import theme from "../../../Styles/theme";
interface ContainerProps {
    interactive?: boolean;
  }
export const Container = styled.div<ContainerProps>`

width:100%;
/* border:solid 1px ${theme.colors.dark}; */
display: flex;
align-items: center;

/* ${({ interactive }) =>
    interactive &&
    css`
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    `} */
`;


export const Table = styled.table`
width:60%;

/* padding: 0.4vh 1vw ; */
height:100%;
`;


export const Th = styled.th`

color:${theme.colors.dark};
font-weight: bold;
font-size: 14px;

`;


export const Td = styled.td`

font-size: 11px;
color:${theme.colors.dark};
text-align:center;
border:solid 0.6px ${theme.colors.dark};
padding: 0.4vh 1vw;
`;



export const Section = styled.div`
width:100%;

`;

export const HelperDiv = styled.div`
    
   display: flex;
align-items: center;
justify-content:space-between;
/* border-left:solid 1px ${theme.colors.dark}; */
color:${theme.colors.dark};
font-weight: bold;
font-size: max(1vw, 8px);

margin:0.5vw;
`;



export const HelperDivNaoTributado = styled.div`
    
   display: flex;
   flex-direction:column;
align-items: center;
justify-content:space-around;
border-left:solid 1px ${theme.colors.dark};
color:${theme.colors.dark};
font-weight: bold;
font-size: 12px;

margin:0.5vw;
`;

export const Label = styled.div`
width:100%;
white-space: nowrap;
font-size: 14px;
`;
export const Value = styled.div`
text-align:center;
padding: 0.4vh 1vw;
border: 1px solid rgba(224, 224, 224, 1);
font-size: 14px;
text-align:center;
color:black;
font-weight:100;

`;


export const TitleConclusao = styled.h1`

    color:${theme.colors.dark};
    font-size: 12px
  

`;
export const Conclusao = styled.div`
 color:${theme.colors.dark};
    font-size: 12px;

    width: 100%;
    height:auto;
    resize: none;

    padding-left:0.5vw;
    padding-right:0.5vw;
    font-weight:normal;

`;